// extracted by mini-css-extract-plugin
export default {"modalOverlay":"style_modalOverlay__nihc7","modalOutcomeText":"style_modalOutcomeText__Yas90","gameOutcomeModal":"style_gameOutcomeModal__z+RMV"};